import Styles from './component.module.scss';
import { useEffect, useState } from 'react';
import { useGetToastMessagesMutation, useMarkToastMessageAsReadMutation } from '../api/MiscAPI';
import { IToastMessageResponseDto } from '../types/Types';
import { useNavigate } from 'react-router-dom';

interface ThisProps {
}

const ToastMessagesComponent: React.FC<ThisProps> = (props) => {

  const navigate = useNavigate();

  const [getToastHinweise] = useGetToastMessagesMutation();
  const [markedToastAsRead] = useMarkToastMessageAsReadMutation();

  const [messages, setMessages] = useState<IToastMessageResponseDto[]>([]);

  const getHinweisListe = async () => {
    getToastHinweise().unwrap()
      .then((data) => {
        setMessages(data);
      })
      .catch((error) => console.log(error))
      ;
  }

  const handleClose = (uid: string) => {
    markedToastAsRead(uid).unwrap()
      .then(getHinweisListe)
      .catch((error) => console.log(error))
      ;
  }

  useEffect(() => {
    getHinweisListe();
  }, [getToastHinweise]);

  return (
    <>
      <div className={Styles.toastContainer}>
        {messages.map((toast) => (
          <div key={toast.uid} className={Styles.toastToast}>
            <span>{toast.text}</span>
            {toast.auftragUid &&
              <>
                <button title={'zum Auftrag'} className="btn btn-info" onClick={() => navigate("eigeneauftraege/detail/" + toast.auftragUid)}><i title={'zum Auftrag'} style={{ cursor: "pointer", fontSize: "18pt" }} className="bi bi-pencil bi-pencil-fill"></i></button>
              </>
            }

            <button onClick={() => handleClose(toast.uid)} className={Styles.toastCloseBtn}>
              <i className="bi bi-x" style={{ fontSize: "35px" }}></i>
            </button>
          </div>
        ))}
      </div>
    </>
  );
}

export default ToastMessagesComponent;
